import { EventIncidentsQueue } from '@collector/desktop-feature-incidents-queue-core'
import { createProvideInject } from '@collector/shared-ui'

export const [provideEventIncidentsQueue, injectEventIncidentsQueue] =
  createProvideInject<EventIncidentsQueue>('eventIncidentsQueue')
